import { Stack } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../redux/actions/auth";
import LoadingBar from "../LoadingBar/LoadingBar";

const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(logout(navigate));
    }, [dispatch, navigate]);

    return (
        <Stack height="100vh" alignItems="center" justifyContent="center">
            <LoadingBar />
        </Stack>
    );
};

export default Logout;
